import { render, staticRenderFns } from "./TaskDetailPage.vue?vue&type=template&id=162116b8&scoped=true&"
import script from "./TaskDetailPage.vue?vue&type=script&lang=js&"
export * from "./TaskDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetailPage.vue?vue&type=style&index=0&id=162116b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162116b8",
  null
  
)

export default component.exports